import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Youtube } from 'lucide-react';
import { Container } from '../ui/Container';
export function Footer() {
  const navigation = {
    product: [{
      name: 'Features',
      href: '/features'
    }, {
      name: 'Pricing',
      href: '/pricing'
    }],
    resources: [{
      name: 'Guides',
      href: '/resources'
    }],
    company: [{
      name: 'About',
      href: '/about'
    }, {
      name: 'Contact',
      href: '/contact'
    }],
    legal: [{
      name: 'Privacy',
      href: '/privacy'
    }, {
      name: 'Terms',
      href: '/terms'
    }, {
      name: 'EULA',
      href: '/eula'
    }],
    social: [{
      name: 'Twitter',
      href: '#',
      icon: (props: any) => <Twitter {...props} data-id="element-70" />
    }, {
      name: 'LinkedIn',
      href: '#',
      icon: (props: any) => <Linkedin {...props} data-id="element-71" />
    }, {
      name: 'YouTube',
      href: '#',
      icon: (props: any) => <Youtube {...props} data-id="element-72" />
    }]
  };
  return <footer className="bg-white border-t border-gray-200" aria-labelledby="footer-heading" data-id="element-73">
      <h2 id="footer-heading" className="sr-only" data-id="element-74">
        Footer
      </h2>
      <Container className="py-12 lg:py-16" data-id="element-75">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-76">
          <div className="space-y-8" data-id="element-77">
            <Link to="/" className="flex items-center space-x-2" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/rSLUSD121ZLtwvfij6sTqX/flowsense.png" alt="Flowsense" className="h-8 w-8" data-id="element-79" />
              <span className="text-xl font-bold text-gray-900" data-id="element-80">Flowsense</span>
            </Link>
            <p className="text-sm leading-6 text-gray-600 max-w-xs" data-id="element-81">
              Turn your Klaviyo flows into revenue machines with AI-powered
              insights and actionable recommendations.
            </p>
            <div className="flex space-x-6" data-id="element-82">
              {navigation.social.map(item => <a key={item.name} href={item.href} className="text-gray-400 hover:text-gray-500" data-id="element-83">
                  <span className="sr-only" data-id="element-84">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" data-id="element-85" />
                </a>)}
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0" data-id="element-86">
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-87">
              <div data-id="element-88">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-89">
                  Product
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-90">
                  {navigation.product.map(item => <li key={item.name} data-id="element-91">
                      <Link to={item.href} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-92">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-93">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-94">
                  Resources
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-95">
                  {navigation.resources.map(item => <li key={item.name} data-id="element-96">
                      <Link to={item.href} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-97">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-98">
              <div data-id="element-99">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-100">
                  Company
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-101">
                  {navigation.company.map(item => <li key={item.name} data-id="element-102">
                      <Link to={item.href} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-103">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-104">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-105">
                  Legal
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-106">
                  {navigation.legal.map(item => <li key={item.name} data-id="element-107">
                      <Link to={item.href} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-108">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24" data-id="element-109">
          <p className="text-xs leading-5 text-gray-500" data-id="element-110">
            &copy; 2025 Flowsense by Acciom Limited. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>;
}